import React from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';

/**
 * Tab de Observacao.
 * Campo simples de texto livre.
 *
 * Props:
 *  - affiliate: objeto atual
 *  - onInputChange(e, name): callback pra alterar campos
 */
export function TabNote({ affiliate, onInputChange }) {
    const { t } = useTranslation();

    return (
        <>
            <p></p>
            <label htmlFor="name">{affiliate.name}</label>
            <p></p>
            <label htmlFor="note">{t('msg.jkaNote')}</label>
            <p></p>
            <InputText id="note" value={affiliate.note} onChange={(e) => onInputChange(e, 'note')} />
        </>
    );
}
